/**
 * A list of HTML attributes that are potentially dangerous, and should be filtered.
 *
 * @type {Set<String>}
 */
export const BLACKLISTED_ATTRIBUTES = new Set([
    'onclick',
    'onload',
    'onblur',
    'onfocus',
    'onerror',
    'onkeydown',
    'onkeypress',
    'onkeyup',
    'onkeyup',
    'onmousedown',
    'onmouseenter',
    'onmouseleave',
    'onmousemove',
    'onmouseout',
    'onmouseover',
    'onmouseup'
]);
